import { render, staticRenderFns } from "./List.vue?vue&type=template&id=61f620ba"
import script from "@/controllers/ap/store/user/List?vue&type=script&lang=ts&external"
export * from "@/controllers/ap/store/user/List?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports